import { Overlay, OverlayConfig } from '@angular/cdk/overlay';
import { TemplatePortal } from '@angular/cdk/portal';
import { Injectable, TemplateRef, ViewContainerRef } from '@angular/core';
import { UntilDestroy } from '@ngneat/until-destroy';

@UntilDestroy()
@Injectable()
export class PopupService {

  constructor(
    private overlay: Overlay
  ) { }

  open<T>(template: TemplateRef<T>, containerRef: ViewContainerRef) {
    const overlayRef = this.overlay.create(this.config());
    const viewRef = overlayRef.attach(new TemplatePortal(template, containerRef));

    return { overlayRef, viewRef };
  }

  private config(): OverlayConfig {
    const config = new OverlayConfig();

    config.positionStrategy = this.overlay.position()
      .global()
      .centerHorizontally()
      .centerVertically();
    config.hasBackdrop = true;
    config.backdropClass = 'mir-instant-backdrop';

    return config;
  }
}
